export default {
  "privacy": {
    "heroTitle": "Politique de Confidentialité",
    "lastUpdated": "Dernière mise à jour : 3 août 2026",
    "sections": [
      {
        "title": "1. Introduction",
        "paragraphs": [
          "IS TELECOM (ci-après « nous », « notre » ou « IS TELECOM ») s'engage à protéger la vie privée et les données personnelles de ses utilisateurs, clients et partenaires. La présente Politique de Confidentialité explique comment nous collectons, utilisons, stockons et protégeons vos données personnelles lorsque vous utilisez notre site internet is-telecom.co (ci-après « le Site ») ou lorsque vous interagissez avec nous.",
          "En utilisant le Site ou en nous communiquant vos données personnelles, vous acceptez les pratiques décrites dans la présente Politique de Confidentialité. Si vous n'acceptez pas cette politique, veuillez ne pas utiliser le Site."
        ]
      },
      {
        "title": "2. Responsable du traitement",
        "paragraphs": [
          "Le responsable du traitement des données personnelles collectées via le Site est IS TELECOM, situé à Cotonou, Bénin.",
          "Téléphone : +229 01 95 89 27 55 — Email : contact@is-telecom.co"
        ]
      },
      {
        "title": "3. Données collectées",
        "paragraphs": ["Nous collectons les catégories de données personnelles suivantes :"],
        "list": [
          "Données d'identification : nom, prénom, nom de l'entreprise",
          "Données de contact : adresse email, numéro de téléphone, adresse postale",
          "Données relatives au projet : type de projet, localisation, budget estimé, description du besoin",
          "Données de navigation : adresse IP, type de navigateur, pages visitées, durée de visite"
        ]
      },
      {
        "title": "4. Finalités du traitement",
        "paragraphs": ["Vos données personnelles sont collectées et traitées pour les finalités suivantes :"],
        "list": [
          "Réponse aux demandes : traiter vos demandes de devis, de contact et d'information",
          "Gestion de la relation client : suivre vos projets, établir des devis, gérer les contrats",
          "Communication : vous informer sur nos services, nos actualités et nos offres (avec votre consentement)",
          "Amélioration du Site : analyser l'utilisation du Site pour en améliorer le contenu et la navigation",
          "Obligations légales : respecter nos obligations légales, réglementaires et fiscales"
        ]
      },
      {
        "title": "5. Base légale du traitement",
        "paragraphs": ["Le traitement de vos données personnelles repose sur l'une des bases juridiques suivantes :"],
        "list": [
          "Exécution d'un contrat : lorsque le traitement est nécessaire à l'exécution d'un contrat",
          "Consentement : lorsque vous avez donné votre consentement explicite",
          "Intérêt légitime : lorsque le traitement est nécessaire aux intérêts légitimes d'IS TELECOM",
          "Obligation légale : lorsque le traitement est nécessaire au respect d'une obligation légale"
        ]
      },
      {
        "title": "6. Durée de conservation",
        "paragraphs": ["Vos données personnelles sont conservées pendant la durée strictement nécessaire :"],
        "list": [
          "Demandes de contact/devis : 3 ans à compter du dernier contact",
          "Données clients et contrats : 10 ans à compter de la fin du contrat",
          "Newsletter et marketing : jusqu'à ce que vous retiriez votre consentement",
          "Données de navigation (cookies) : 13 mois maximum"
        ]
      },
      {
        "title": "7. Partage des données",
        "paragraphs": [
          "IS TELECOM ne vend ni ne loue vos données personnelles à des tiers. Vos données peuvent toutefois être partagées avec des prestataires de services (hébergeur web, outils d'analyse, services de messagerie), des autorités compétentes lorsque la loi l'exige, ou des partenaires commerciaux uniquement avec votre consentement préalable."
        ]
      },
      {
        "title": "8. Sécurité des données",
        "paragraphs": [
          "IS TELECOM met en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles : chiffrement des données en transit (HTTPS/TLS), accès restreint selon les rôles, formation des employés, surveillance et audit réguliers."
        ]
      },
      {
        "title": "9. Vos droits",
        "paragraphs": [
          "Conformément à la législation en vigueur, vous disposez des droits suivants : droit d'accès, droit de rectification, droit à l'effacement, droit à la limitation, droit d'opposition, droit à la portabilité."
        ]
      },
      {
        "title": "10. Cookies et technologies similaires",
        "paragraphs": [
          "Le Site utilise des cookies essentiels, de performance, de fonctionnalité et de ciblage. Vous pouvez gérer vos préférences via les paramètres de votre navigateur."
        ]
      },
      {
        "title": "11. Transferts internationaux",
        "paragraphs": [
          "IS TELECOM est présente dans 6 pays d'Afrique. Vos données peuvent être transférées et traitées dans des pays autres que celui où vous résidez, avec des garanties appropriées pour protéger vos données."
        ]
      },
      {
        "title": "12. Modifications de la politique",
        "paragraphs": [
          "IS TELECOM se réserve le droit de modifier la présente Politique de Confidentialité à tout moment. Toute modification sera publiée sur cette page avec la date de mise à jour."
        ]
      },
      {
        "title": "13. Contact",
        "paragraphs": [
          "Pour toute question relative à la présente Politique de Confidentialité ou pour exercer vos droits, contactez-nous : IS TELECOM — Délégué à la Protection des Données, Cotonou, Bénin. Téléphone : +229 01 95 89 27 55. Email : contact@is-telecom.co"
        ]
      }
    ]
  }
};